.kc{white-space:nowrap;}